import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const approvePettyCashCommonRequest = createAsyncThunk(
	"approvePettyCashCommonRequest",
	async ({ id, data }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put(`petty-cash/common-request/${id}/status`, data);
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	}
);

const PettyCashCommonRequestApproveSlice = createSlice({
	name: "PettyCashCommonRequestApproveSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetPettyCashCommonRequestApproveState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(approvePettyCashCommonRequest.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(approvePettyCashCommonRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(approvePettyCashCommonRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashCommonRequestApproveState } = PettyCashCommonRequestApproveSlice.actions;
export default PettyCashCommonRequestApproveSlice.reducer;
